import { TasknameService } from './service/taskname.service';
import { Component, Input, OnInit } from '@angular/core';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { Task } from '@src/app/models/task';


import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-taskname',
  templateUrl: './taskname.component.html',
  styleUrls: ['./taskname.component.css']
})
export class TasknameComponent implements OnInit {
task:Task;
//input we are getting values passed from outside.
@Input() taskId:string;
@Input() projectId:string;
@Input() viewtypeshort:boolean;
// constructor (private servicename:Service)
  constructor(
    private tsvc:TasknameService,
    private datastore:DatastoreService,
  ) { }

  ngOnInit() {
    this.task = new Task;
    //substring to trim the taskId get rid of versioning
    if (sessionStorage.getItem('task_'+this.taskId)) {
      this.task = JSON.parse(sessionStorage.getItem('task_'+this.taskId))
    } else {
      let taskList = this.datastore.taskList.getValue();
        if (taskList) {
          this.task = taskList.find(t => t.taskId.split('_')[0] === this.taskId.split('_')[0]);
          if (this.task) {
            sessionStorage.setItem('task_'+this.taskId,JSON.stringify(this.task));
          }
        }
    //   this.tsvc.getTaskname(this.taskId.substring(0,36),this.projectId).pipe(untilDestroyed(this)).subscribe(taskName =>{
    //     sessionStorage.setItem('task_'+this.taskId,JSON.stringify(taskName));
    //     this.task = taskName;
    //   });
    }
   
  }

}
